export default {
    computed: {
        showEmptyChart () {
            if (this.data === undefined || this.data.length === 0) {
                return true
            }

            let nonZeroData = this.data.find(el => el !== 0)
            return !nonZeroData
        }
    }
}
